import IS_EFAS from '../../../components/sitebase/Environment.ts';
import { getCSRFToken } from '../../../components/sitebase/components/CookieHelper.ts';

/**
 * Features that can be rated by the user. Only the legend is collected for now,
 * new entries must be kept in sync with the backend FeatureFeedback.Feature choices.
 */
export enum FeedbackFeature {
    LEGEND = 'legend',
}

export enum FeedbackRating {
    YES = 'yes',
    NO = 'no',
    UNSURE = 'unsure',
}

export interface FeatureFeedbackPayload {
    feature: FeedbackFeature;
    rating: FeedbackRating;
    comment?: string;
    context?: { [key: string]: unknown };
}

/**
 * Sends a single feedback entry. A user can submit as many as they want,
 * every call creates a new record on the backend.
 *
 * @returns true when the feedback was stored
 */
export async function submitFeatureFeedback(payload: FeatureFeedbackPayload): Promise<boolean> {
    const csrf = !IS_EFAS ? { 'X-CSRFToken': getCSRFToken() } : null;

    try {
        const response = await fetch("/api/feature-feedback/", {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...csrf
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            console.error("Failed to send feedback", response);
            return false;
        }
        return true;
    } catch (e) {
        console.error("Failed to send feedback", e);
        return false;
    }
}
